import { successColor } from "assets/jss/material-dashboard-react.jsx";

const dashboardStyle = {
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px"
  },
  stats: {
    color: "#999999",
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    }
  },
  cardCategory: {
    color: "#999999",
    margin: "0",
    fontSize: "20px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0"
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitle: {
    color: "#3C4858",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardIconTitle: {
    color: "#3C4858",
    margin: "10px 0 0",
    fontWeight: "300"
  },
  deviceSummaryCardIcon: {
    padding: "0px !important"
  },
  statusSummaryContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap"
  },
  statusSummaryItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap",
    maxWidth: "170px"
  },
  StatusIndicatorWidgetAnchor: {
    width: "100%"
  },
  StatusSummaryItemTitle: {
    minWidth: "130px"
  },
  StatusSummaryItemWidget: {
    width: "auto",
    minWidth: "130px"
  },
  ExternalDashboardContainer: {
    width: "100%"
  },
  ExternalDashboardTitle: {
    width: "100%",
    color: "#235894",
    fontSize: "x-large",
    paddingTop: "25px",
    paddingBottom: "25px"
  },
  ExternalDashboardROW: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%"
  },
  ExternalDashboardChart: {
    width: "100%"
  },
  ExternalDashboardChartTitle: {
    width: "100%",
    color: "#235894",
    fontSize: "x-large",
    paddingBottom: "25px"
  }
};

export default dashboardStyle;
